import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import { RootStoreContext } from "../app/stores/rootStore";
import MainNavBar from "../components/navbars/MainNavBar";
import Sidebar from "../components/navbars/Sidebar";
import SurveyModal from "../components/survey/SurveyModal";
import BoardBrowsePage from "../views/BoardBrowsePage";
import BoardPage from "../views/BoardPage";
import MeetingBrowsePage from "../views/MeetingBrowsePage";
import MeetingsPage from "../views/MeetingsPage";
import MeetingTreePage from "../views/MeetingTreePage";
import NotFoundPage from "../views/NotFoundPage";
import RepositoryBrowsePage from "../views/RepositoryBrowsePage";
import RepositoryUserPage from "../views/RepositoryUserPage";
import SearchPage from "../views/SearchPage";
import ZwibblerTestPage from "../views/ZwibblerTestPage";
import MobileSidebarModal from "../components/navbars/MobileSidebarModal";
import ArchivePage from "../views/ArchivePage";
import ArchiveContentPage from "../views/ArchiveContentPage";
import ArchiveBrowsePage from "../views/ArchiveBrowsePage";
import BroadcastController from "../components/broadcast_Openvidu/BroadcastController";

const TenantDashboardLayout: React.FC<RouteComponentProps> = ({
  history,
  location,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { currentTenant, tenantArray } = rootStore.tenantStore;
  const { user } = rootStore.userStore;
  const { theme } = rootStore.commonStore;
  const { isBroadcastControllerOpen } = rootStore.broadcastStore;
  const [containerClass, setContainerClass] = useState("100");
  const {reloadMeetings}=rootStore.meetingStore;
  
  useEffect(() => {

    document.body.classList.remove("form-membership");
    document.body.classList.add("pt-0", `bg-${theme!.backgroundColor}`);
    isBroadcastControllerOpen ?  setContainerClass(`broadcastControllerON`) : setContainerClass(`broadcastControllerOFF`);
    return () => {
      // document.body.classList.remove("NavbarShift");
    };
  }, [isBroadcastControllerOpen, theme]);

  return (
    <>        
      <Sidebar
        tenant={currentTenant!}
        currentUrl={location.pathname}
        goBack={history.goBack}
      />
      <MainNavBar
        currentTenant={currentTenant!}
        currentUrl={location.pathname}
        allTenants={tenantArray!}
        user={user!}
        goBack={history.goBack}
      />
      <Row style={{flexWrap: "nowrap"}}>
        <Col className={containerClass}>
      <Container fluid>
        <Switch>
          <Route exact path="/:tenant/meetings" component={MeetingsPage} />
          <Route
            exact
            path="/:tenant/meeting/:meetingId"
            component={MeetingTreePage}
          />
          <Route exact path="/:tenant/archives" component={ArchivePage} />
          <Route
            exact
            path="/:tenant/archives/:archiveId"
            component={ArchiveContentPage}
          />
          <Route
            exact
            path="/:tenant/archives/browse/:archiveId/content/:contentId"
            component={ArchiveBrowsePage}
          />
          <Route exact path="/:tenant/board" component={BoardPage} />
          <Route exact path="/:tenant/search" component={SearchPage} />
          <Route
            exact
            path="/:tenant/browse/meetings/:meetingId/content/:nodeId"
            component={MeetingBrowsePage}
          />
          <Route
            exact
            path="/:tenant/browse/boards/:boardId/content/:nodeId"
            component={BoardBrowsePage}
          />
          <Route exact path="/:tenant/zwibbler" component={ZwibblerTestPage} />
          <Route
            exact
            path="/:tenant/repository"
            component={RepositoryUserPage}
          />
          <Route
            exact
            path="/:tenant/repositoryBrowse/:presentationId"
            component={RepositoryBrowsePage}
          />
          <Route component={NotFoundPage} />
        </Switch>
      </Container>
      </Col>
      {isBroadcastControllerOpen && (
      <Col className={"broadcastController"}>
      <BroadcastController/>
      </Col>
      )}
      </Row>
      <SurveyModal />
      <MobileSidebarModal         tenant={currentTenant!}
        currentUrl={location.pathname}
        goBack={history.goBack}/>
    </>
  );
};

export default observer(TenantDashboardLayout);
